/* 🤖 this file was generated by svg-to-ts */
export const emperorIconLock1: {
  name: 'lock_1';
  data: string;
} = {
  name: 'lock_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M17 11V7c0-2.76-2.25-5-5-5C9.24 2 7 4.24 7 7v4c-1.11 0-2 .89-2 2v7c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2v-7c0-1.11-.9-2-2-2Zm-5 7c-.83 0-1.5-.68-1.5-1.5 0-.83.67-1.5 1.5-1.5 .82 0 1.5.67 1.5 1.5 0 .82-.68 1.5-1.5 1.5Zm3-7H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v4Z"/></svg>`,
};
